export const models = [
  {
    value: 'ultra',
    label: 'Ultra',
  },
  {
    value: 'plus',
    label: 'Plus',
  },
  {
    value: 'pro',
    label: 'Pro',
  },
];

export const languages = [
  {
    value: 'English',
    label: 'English',
  },
  {
    value: 'Simplified Chinese',
    label: 'Simplified Chinese',
  },
  {
    value: 'Traditional Chinese',
    label: 'Traditional Chinese',
  },
  {
    value: 'Hindi',
    label: 'Hindi',
  },
  {
    value: 'Spanish',
    label: 'Spanish',
  },
  {
    value: 'Vietnamese',
    label: 'Vietnamese',
  },
  {
    value: 'German',
    label: 'German',
  },
  {
    value: 'Danish',
    label: 'Danish',
  },
  {
    value: 'Italian',
    label: 'Italian',
  },
  {
    value: 'French',
    label: 'French',
  },
  {
    value: 'Russian',
    label: 'Russian',
  },
];

export const fileTypeItems = [
  {
    value: 'page',
    label: 'page',
  },
  {
    value: 'text_formula',
    label: 'text_formula',
  },
  {
    value: 'formula',
    label: 'formula',
  },
  {
    value: 'text',
    label: 'text',
  },
];

export const exportItems = [
  {
    value: 'docx',
    label: 'docx'
  },
  {
    value: 'pdf',
    label: 'pdf'
  },
];
